const UPDATE_NAME_DELAY = 500;
const UPDATE_GIT_TAGS_DELAY = 500;
// Local storage keys
const STORAGE_KEYS = {
    LAST_VISITED_ORG: 'zephyr:lastVisitedOrg',
    EXPANDED_PROJECTS: 'zephyr:expandedProjects',
    SEARCH_QUERY: 'zephyr:searchQuery',
    IS_SIDEBAR_OPEN: 'zephyr:isSidebarOpen'
};
export { STORAGE_KEYS, UPDATE_GIT_TAGS_DELAY, UPDATE_NAME_DELAY };
